export const CPT_PC_TC_INDICATORS: Record<string, string> = {
  "20526": "0",
  "20550": "0",
  "20551": "0",
  "20604": "0",
  "20606": "0",
  "20611": "0",
  "51798": "3",
  "64450": "0",
  "76512": "1",
  "76529": "1",
  "76536": "1",
  "76604": "1",
  "76705": "1",
  "76706": "1",
  "76770": "1",
  "76775": "1",
  "76815": "1",
  "76817": "1",
  "76857": "1",
  "76870": "1",
  "76881": "1",
  "76882": "1",
  "76942": "1",
  "93306": "1",
  "93308": "1",
  "93321": "1",
  "93325": "1",
  "93971": "1",
};
